// string 관련 유틸리티
import Vue          from 'vue';
import { SDLUtil } from '@/utils';

/*
 * desc : url 쿼리 문자열로 변경
 * param : Object
 */
export const queryStringfy = obj => {
    const str = [];
    Object.keys(obj).forEach(key => {
        if (obj[key]) {
            str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
        }
    });

    return str.join('&');
};

/*
 * desc : 입력된 문자열이 url 패턴인지 체크
 * param : {
 *           str : String
 *         }
 */
export const checkPatternUrl = str => {
    const expUrl = /^(http\:\/\/)?((\w+)[.])+(asia|biz|cc|cn|com|de|eu|in|info|jobs|jp|kr|mobi|mx|name|net|nz|org|travel|tv|tw|uk|us)(\/(\w*))*$/i;
    return expUrl.test(str);
};

/*
 * desc : 입력된 문자열에 위험한 문자가 있는지 확인.
 * param : {
 *           str : String
 *         }
 * return: boolean. true = 안전, false = 위험 문자포함
 */
export const hasUnsafeChars = str => {
    return RegExp(/[!@#$%^&*":{}|<>]/, 'g').test(str);
};

/**
 * desc : url 쿼리 문자열 추출
 * param : url
 * return : url query object
 */
export const getAllUrlParams = url => {
    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');

            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {

                // create key if it doesn't exist
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    // otherwise add the value to the end of the array
                    obj[key].push(paramValue);
                }
            } else {
                // we're dealing with a string
                if (!obj[paramName]) {
                    // if it doesn't exist, create property
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string'){
                    // if property does exist and it's a string, convert it to an array
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    // otherwise add the property
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
};

/*
 * desc : combobox의 값을 가져옴
 * param : element id
 */
export const getComboboxValue = comboId => {
    return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
};

/*
 * desc : html 태그 제거
 * param : String text
 */
export const removeHtmlTag = htmlText => {
    if(typeof(htmlText) == "string"){
        try{
            // Crosseditor 에서 escape 된 html 을 다시 html 형식으로 변환 후 html tag 완전 제거
            let doc = new DOMParser().parseFromString(htmlText, "text/html");
            // 제거하기 전, style tag 의 내용은 삭제한다.
            if(doc.getElementsByTagName('style').length > 0) {
                let styles = doc.getElementsByTagName('style');
                for(let i = 0; i < styles.length; i++){
                    let style = styles[i];
                    style.parentElement.removeChild(style);
                    // style.remove();
                }
            }
            return (doc.documentElement.textContent).replace(/(<([^>]+)>)/gi, "").trim();

        } catch(e) {
            return "";
        }

    } else {
        return "";
    }
};

/**
 * desc : menu group detail code conversion
 * param : Menu Code
 */
export const repMenuGrpDtlCd = (menuGrpDtlCd) => {

    // Local menu convert
    const MENU_CONV_CHART = {
        "KSML"  : "SM", // Local Service Manual
        "KSBL"  : "SB", // Local Service Bulletin
        "KTTM"  : "TM", // Technical Training Manual
        "KRRT"  : "RT", // Repeated Repair Tip
        "KRTT"  : "RT", // Local Repair Tip
        "KAGT"  : "AT", // Local General Tip
        "KATM"  : "AT", // Agent Training Manual
    };

    return nvl(MENU_CONV_CHART[menuGrpDtlCd], menuGrpDtlCd);
};

/**
 * desc : menu group detail local code conversion
 * param : Menu Code
 */
export const repServiceScriptGrpCd = (orgMenuGrpDtlCd) => {
    const LOCAL_CONV_CHART = {
        "SM" : "KSML",  // Service Manual
        "SB" : "KSBL",  // Service Bulletin
        "AT" : "KAGT",  // Agent Tip
        "RT" : "KRTT"   // Repair Tip
    };

    return nvl(LOCAL_CONV_CHART[orgMenuGrpDtlCd], orgMenuGrpDtlCd);
};

/**
 * desc : knowledge title combine & 270bytes
 * param : Menu Code, GBM Code, Subject
 */
export const createSubject = (menuGrpCd, gbmCd, subject) => {
    let prefix = "", title = "",
        len = 270, prefixReserved = 23; /* prefix max -> '[Digital Appliance:SM] '*/
    let isCd = false, isDbl = false;
        len = len - prefixReserved;

    const GBM_CHART = {
        "1"     : "VD",
        "2"     : "VD",
        "3"     : "VD",
        "4"     : "VD",
        "5"     : "Computer",
        "6"     : "HDD",
        "7"     : "OMS",
        "8"     : "Printer",
        "9"     : "Mobile",
        "10"    : "Living",
        "11"    : "REF",
        "12"    : "Air Conditioner",
        "13"    : "Vacuum Cleaner",
        "16"    : "MD",
        "17"    : "DSC",
        "18"    : "Network",
        "19"    : "Memory",
        "20"    : "HME",
        "21"    : "W/M",
        "22"    : "MWO",
        "23"    : "DWM",
        "25"    : "RX",
        "99"    : "Others"
    };
    
    Vue.$log.info("※ StringUtil.createSubject / Menu Group Code:", menuGrpCd, "/ Model GBM Code:", gbmCd, "/", GBM_CHART[gbmCd], "/ Title:", subject);

    if(!isNull(menuGrpCd) || !isNull(gbmCd)) { isCd = true; }
    if(!isNull(menuGrpCd) && !isNull(gbmCd)) { isDbl = true; }

    prefix = (isCd ? "[" : '')
           + ( !isNull(gbmCd) ? nvl(GBM_CHART[gbmCd], gbmCd, ""/*GBM_CHART[99]*/) : "" )
           + (isDbl ? ":" : '')
           + ( !isNull(menuGrpCd) ? repMenuGrpDtlCd(menuGrpCd) : "" )
           + (isCd ? "]" : '');

    title = prefix + subject.replace(/(\[([^>]+)\])/gi, "").trim();

    if(textLength(title) > len) {
    	//AS-IS
        //alert(getMsgProp("MESSAGE.DATA.MAX.LENGTH", ["270"]));   -- The code throws an error, so it cannot be saved.
    	//TO-BE
        alert(SDLUtil.getMsgProp("MESSAGE.DATA.MAX.LENGTH", ["270"]));
        title = title.substring(0, 270);
        return title;

    } else {
        return title;
    }
};

/**
 * desc : Generate GUID
 * return : guid
 */
export const guid = () => {
    function s4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

/**
 * desc : boolean -> String
 * param : boolean
 * return : string
 */
export const boolToStr = (val = false) => {
    return val ? 'Y' : 'N';
};

/**
 * desc : String -> boolean
 * param : string
 * return : boolean
 */
export const strToBool = (val = 'N') => {
    const strTrue   = ['1', 'Y', 'YES', 'TRUE', '네', '예스'];
    const strFalse  = ['0', 'N', 'NO', 'FALSE', '아니오', '아니요', '노'];
    if( !isNaN( Number(val) ) ) {
        val = String(val > 0 ? 1 : 0);
    };

    val = val.toUpperCase();
    if(strTrue.includes(val)) {
        val = 'Y';

    } else if(strFalse.includes(val)) {
        val = 'N';

    } else {
        val = 'N';
    };

    return val === 'Y' ? true : false;
};

/**
 * desc : Number format
 * param : number
 * return : string
 */
 export const numberFormat = (number) => {
    return String(number).replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
};

/**
 * desc : Number to Unit format
 * param : number
 * return : string
 */
export const formatToUnits = (number, precision) => {
    const abbrev = ['', 'K', 'M', 'B', 'T'];
    const unrangifiedOrder = Math.floor(Math.log10(Math.abs(number)) / 3)
    const order = Math.max(0, Math.min(unrangifiedOrder, abbrev.length -1 ))
    const suffix = abbrev[order];

    return (number / Math.pow(10, order * 3)).toFixed(precision) + suffix;
};

/**
 * desc : random web color by chart
 * return : string
 */
export const getRandomColor = () => {
    let letters = '0123456789ABCDEF', color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }

    return color;
};

/*
 * desc : 빈값반환규칙
 * strA가 빈값이면 strB반환 또는 strB도 빈값이면 '' 반환
 * strA가 빈값이 아니면 strA반환 또는 strC가 있다면 strA가 아니라 strC반환
 * param : {
 *           strA : String
 *           strB : String
 *           strC : String
 *         }
 */
export const nvl = (strA, strB, strC) => {
    let returnValue = '';
    if (isNull(strA)) {
        if (isNull(strB)) {
            returnValue = '';
        } else {
            returnValue = strB;
        }
    } else {
        if (isNull(strC)) {
            returnValue = strA;
        } else {
            returnValue = strC;
        }
    }

    return returnValue;
};

/**
 * Null check
 * param: v
 * return: boolean
 */
export const isNull = (v) => {
    let test = (v + '').trim(), testResult = false;
    if (
        test === '' ||
        test === null ||
        test === 'null' ||
        test === undefined ||
        test === 'undefined' ||
        test === 'UNDEFINED' ||
        typeof test === undefined ||
        typeof test === 'undefined' ||
        ( test != null && typeof test == "object" && !Object.keys(test).length )
    ) {
        testResult = true;
    }

    return testResult;
};

/**
 * Text length check function
 * param: v, max, min
 * return: boolean
 */
export const lengthCheck = (v, max, min) => {
    let returnValue = false;
    let checkValue = textLength(v);
    if (isNull(min)) min = 0;
    if (typeof min === 'number' && typeof max === 'number' && min <= checkValue && checkValue <= max) {
        returnValue = true;
    }
    return returnValue;
};

/**
 * Text length return function
 * return: (int) text length
 */
export const textLength = (v) => {
    let len = 0;
    for (let i = 0; i < v.length; i++) {
        if (escape(v.charAt(i)).length == 6) {
            len++;
            len++;
        }
        len++;
    }
    return len;
};

// 배열에서 object 존재여부 체크(true: 존재함)
export const existArrays = (array, key, val) => {
    let bRes = false;
    array.forEach(elm => {
        let data = eval('elm.' + key);
        if (val == data) {
            bRes = true;
            return;
        }
    });
    return bRes;
};

// 정수만 입력 가능
export const onlyNumber = (event) => {
    $(event.target).val($(event.target).val().replace(/[^0-9]/g, ""));
};

// html 제거
export const stripHtml = (html) => {
    let tmp = document.createElement('html');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
};

// XSS decode
export const decodeXSS = (str = "") => {
    return str.replace(/&quot;/g, '\"').replace(/&#39;/g, '\'').replace(/&#35;/g, '#').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};

// UTF8 -> base64 encoding
export const utf8ToBase64 = (str = "") => {
    return window.btoa(unescape(encodeURIComponent( str )));
};

// encoded base64 to utf8 decoding
export const base64ToUtf8 = (str = "") => {
    str = str.replace(/\s/g, '');    
    return decodeURIComponent(escape(window.atob( str )));
};

/**
 * desc : Toast grid message map
 * param : (String) language code
 * return : language message map
 */
export const gridMessageMap = (lang = 'en') => {
    const MESSAGE_MAP = {
        en: {
            display: {
                noData: 'No data found.',
                loadingData: 'Loading data.',
                resizeHandleGuide: 'You can change the width of the column by mouse drag, and initialize the width by double-clicking.'
            },
            net: {
                confirmCreate: 'Are you sure you want to create {{count}} data?',
                confirmUpdate: 'Are you sure you want to update {{count}} data?',
                confirmDelete: 'Are you sure you want to delete {{count}} data?',
                confirmModify: 'Are you sure you want to modify {{count}} data?',
                noDataToCreate: 'No data to create.',
                noDataToUpdate: 'No data to update.',
                noDataToDelete: 'No data to delete.',
                noDataToModify: 'No data to modify.',
                failResponse: 'An error occurred while requesting data.\nPlease try again.'
            }
        },
        ko: {
            display: {
                noData: 'No data found.',
                loadingData: 'Loading data.',
                resizeHandleGuide: '마우스 드래그하여 컬럼 너비를 조정할 수 있고, 더블 클릭으로 컬럼 너비를 초기화할 수 있습니다.'
            },
            net: {
                confirmCreate: '{{count}}건의 데이터를 생성하겠습니까?',
                confirmUpdate: '{{count}}건의 데이터를 수정하겠습니까?',
                confirmDelete: '{{count}}건의 데이터를 삭제하겠습니까?',
                confirmModify: '{{count}}건의 데이터를 처리하겠습니까?',
                noDataToCreate: '생성할 데이터가 없습니다.',
                noDataToUpdate: '수정할 데이터가 없습니다.',
                noDataToDelete: '삭제할 데이터가 없습니다.',
                noDataToModify: '처리할 데이터가 없습니다.',
                failResponse: '데이터 요청 중에 에러가 발생하였습니다.\n다시 시도하여 주시기 바랍니다.'
            }
        }
    };

    // MESSAGE_MAP에 없는 언어는 en 으로 출력한다.
    if( typeof(MESSAGE_MAP[lang]) === 'undefined' ) lang = 'en';

    return MESSAGE_MAP[lang] || {};
};

/**
 * desc : Lorem ipsum dolor..
 * return : string 445bytes
 */
export const lorem = () => {
    return "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
}

export default {
    queryStringfy,
    checkPatternUrl,
    getAllUrlParams,
    hasUnsafeChars,
    getComboboxValue,
    removeHtmlTag,
    repMenuGrpDtlCd,
    repServiceScriptGrpCd,
    createSubject,
    guid,
    boolToStr,
    strToBool,
    numberFormat,
    formatToUnits,
    getRandomColor,
    nvl,
    isNull,
    lengthCheck,
    textLength,
    existArrays,
    onlyNumber,
    stripHtml,
    decodeXSS,
    utf8ToBase64,
    base64ToUtf8,
    gridMessageMap,
    lorem
};


// WEBPACK FOOTER //
// ./src/utils/StringUtil.js